import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Create_record extends PureComponent {
  render() {
    return (
      <div className="row" id="create_record">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Create Record</h2>
              <p>
                The record create function is the main function for creating
                records in the Nexoid API. Records live in “object types” which
                contextually are the same as tables in a SQL database. Object
                types are generated on the fly and will come into existence upon
                the creation of a record. Object types do not support special
                characters and must be at least 3 characters long and are
                limited to 196 characters.
              </p>
              <p>
                The create record function supports creating an individual
                record see example 1 or bulk creation of records see example 2.
                Bulk creating records is limited to 50 records per API call. But
                creation will not return the newly created record only a summary
                of new IDs and any failures.{" "}
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Create Record Example</h2>
            </section>
            <section>
              <h3>Example 1: Single Record</h3>
              <p>This example will create a single record.</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Greg"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"long_room_no"</span>:{" "}
                  <span className="jsonP">4</span>
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"453"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Greg"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"long_room_no"</span>:{" "}
                  <span className="jsonP">4</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"object_created_by"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"date_created"</span>:{" "}
                  <span className="jsonY">"2016-03-08T13:04:16.069Z"</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"object_updated_by"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"date_created"</span>:{" "}
                  <span className="jsonY">"2016-03-08T13:04:16.069Z"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Multiple Records</h3>
              <p>This example will create a 3 records.</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"records"</span>: [
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Greg"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"long_room_no"</span>:{" "}
                  <span className="jsonP">4</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Bob"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"long_room_no"</span>:{" "}
                  <span className="jsonP">6</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Sally"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"long_room_no"</span>:{" "}
                  <span className="jsonP">2</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">]</div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"created"</span>: [
                  <span className="jsonY">"453"</span>,{" "}
                  <span className="jsonY">"454"</span>,{" "}
                  <span className="jsonY">"455"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"failed"</span>:{" "}
                  <span className="jsonP">0</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Create_record;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Create_record.js